module.exports = __webpack_public_path__ + "static/02-90f2c83632ca1dca5dc739cfa69c06bc.jpg";